import { generatePath } from 'react-router';

import { RouteParamCollection } from 'types/routes';

export const routeBuilder = <K extends string>(path: K, params?: RouteParamCollection<K>): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return generatePath(path, params as any);
};
